import React, { useEffect } from "react";
import { Col } from "react-bootstrap";
import Awareness from "./sections/Awareness";
import LearningModules from "./sections/LearningModules";
import Documents from "./sections/Documents";
import Feedback from "../../components/feedbackNote/Feedback";
import { useAppDispatch } from "../../app/hooks";
import { GetLogsTracker } from "../../features/login/logsTracker";
import { useParams } from "react-router-dom";

const Learning = () => {
  const dispatch = useAppDispatch();
  let params: any = useParams();
  let categoryId: any = params?.categoryId ? params?.categoryId : "";
  // const LogsTracker = useAppSelector(selectLogsTracker);
  var moduleName = "Learning";
  useEffect(() => {
    async function fetchLogsTracker() {
      await dispatch(GetLogsTracker(moduleName));
    }
    fetchLogsTracker();
  }, []);

  return (
    <>
      <div className="mob">
        <p style={styles.learning}>Ethics Awareness</p>
      </div>
      <Feedback pageName="Ethics Awarness" />

      {/*  ===================================
        Added this condition for SPEAK up Category as instructions from Jyotsana Mandal 
        during Teams meeting held on 14th Aug 2023
      =============================  */}
      {categoryId !== 5 && (
        <>
          <LearningModules />
          <br />
        </>
      )}

      <Awareness />
      {/*  ===================================
        Added this condition for SPEAK up Category as instructions from Jyotsana Mandal 
        during Teams meeting held on 14th Aug 2023
      =============================  */}
      {categoryId !== 5 && (
        <Col lg={12}>
          <Documents />
        </Col>
      )}
    </>
  );
};

const styles: any = {
  learning: {
    fontFamily: "Georama-Regular",
    fontSize: "16px",
    fontWeight: "800",
    marginTop: "10px",
  },
};

export default Learning;
